module.exports = __webpack_public_path__ + "img/Administrator-icon.686420ea.png";